<template>
  <div class="tradeModel">
    <div class="layout">
      <div class="money">
        <ul>
          <li><p>交易总手数</p><span v-if="profitAndLoss.total">{{ profitAndLoss.total.tradeVolume?parseFloat(profitAndLoss.total.tradeVolume).toFixed(2):'0.00' }}手</span></li>
          <li><p>总盈亏</p><span v-if="profitAndLoss.total" :class="classType(profitAndLoss.total.profit)">{{ profitAndLoss.total.profit&&profitAndLoss.total.profit>0?'+':profitAndLoss.total.profit==0?'':'-' }}${{ parseFloat(profitAndLoss.total.profit).toFixed(2).replace('-','').replace('+','') }}<em /></span></li>
          <li><p>总利息</p><span v-if="profitAndLoss.total">{{ profitAndLoss.total.swap&&profitAndLoss.total.swap>0?'+':profitAndLoss.total.swap==0?'':'-' }}${{ parseFloat(profitAndLoss.total.swap).toFixed(2).replace('-','').replace('+','') }}</span></li>
        </ul>
      </div>
      <div class="reportTit">
        <p>共计{{ profitAndLoss.totalSize }}条记录</p>
        <span @click="selectBrush">筛选<img src="@/assets/images/template/SX.png"></span>
      </div>
    </div>
    <div v-if="profitAndLoss.recordList" class="reportList">
      <ul v-if="profitAndLoss.recordList.length>0">
        <li v-for="item in profitAndLoss.recordList" @click="selectProfitAndLossPro(item)">
          <div class="item">
            <span>{{ item.displayName }}<em>#{{ item.dealId }}</em></span>
            <em>{{ timeZone(item.tradeTime) }}</em>
          </div>
          <div class="item">
            <div class="itemCon">
              <div class="flexStart">
                <div class="itemWidth"><p class="p_mode" :class="classType(item.openDirection)">{{ item.orderTypeStr }}{{ item.openDirection }}</p><p>{{ item.tradeVolume }}手</p></div>
                <div class="itemWidth"><p class="color">开仓价</p><p>{{ item.openPriceStr }}</p></div>
              </div>
              <div class="flexStart">
                <div class="itemWidth"><p class="color">利息</p><p>{{ item.swap }}</p></div>
                <div class="itemWidth"><p class="color">平仓价</p><p>{{ item.tradePriceStr }}</p></div>
              </div>
            </div>
            <div class="flexEnd"><p v-if="item.profit" class="size" :class="classType(item.profit)">{{ item.profit>0?'+':'-' }}${{ parseFloat(item.profit).toFixed(2).toString().replace("-","") }}</p></div>
          </div>
        </li>
      </ul>
      <noData v-else />
    </div>
    <!--盈亏详情-->
    <div v-if="isShowProfitAndLoss" class="popFixed">
      <div class="masking" @click="closeProfitAndLossPop" />
      <div class="tcCon">
        <div class="holdBank between">
          <div class="item">
            <span>交易详情</span>
            <ul>
              <li><span>成交号</span><span>{{ dealId?"#":'' }}{{ dealId }}</span></li>
              <li><span>产品</span><span>{{ displayName }}</span></li>
              <li><span>类型</span><span>{{ orderTypeStr }}</span></li>
              <li><span>开仓方向</span><span>{{ openDirection }}</span></li>
              <li><span>平仓手数</span><span>{{ tradeVolume }}</span></li>
              <li><span>平仓价</span><span>{{ tradePriceStr }}</span></li>
              <li><span>开仓价</span><span>{{ openPriceStr }}</span></li>
              <li><span>利息</span><span>{{ swap }}</span></li>
              <li><span>盈亏</span><span>{{ parseFloat(profit).toFixed(2) }}</span></li>
              <li><span>佣金</span><span>{{ commission }}</span></li>
              <li><span>持仓号</span><span>{{ openNo?"#":'' }}{{ openNo }}</span></li>
              <li><span>开仓时间</span><span>{{ timeZone(openTime) }}</span></li>
              <li><span>平仓时间</span><span>{{ timeZone(tradeTime) }}</span></li>
              <li><span>备注</span><span>{{ remark }}</span></li>
            </ul>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="closeProfitAndLossPop">知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import noData from '@/view/module/noData.vue'
import utils from '@/utils/tradeDataUtil'
export default {
  displayName: 'ProfitAndLossRecord',
  components: { noData },
  props: ['profitAndLoss', 'isBrushTradePop'],
  data() {
    return {
      isShowProfitAndLoss: false,
      dealId: '',
      displayName: '',
      orderTypeStr: '',
      openDirection: '',
      tradeVolume: '',
      tradePriceStr: '',
      openPriceStr: '',
      swap: '',
      profit: '',
      dealid: '',
      commission: '',
      openNo: '',
      openTime: '',
      tradeTime: '',
      remark: '',
      scrollHeight: '',
      pattern: this.$route.query.pattern || '',
      timeZones: this.$route.query.timeZones || ('GMT+8')
    }
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    removeStyle() {
      const main = document.getElementById('main')
      main.removeAttribute('style')
      window.scrollTo(0, this.scrollHeight)
    },
    addStyle() {
      const main = document.getElementById('main')
      let top, body, css
      if (document.documentElement) {
        body = document.documentElement
      } else if (document.body) {
        body = document.body
      }
      if (body.scrollTop) {
        top = body.scrollTop
      } else if (window.pageYOffset) {
        top = window.pageYOffset
      }
      css = 'width: 100%; height: 100%; position: fixed; top: -' + top + 'px;left: 0;'
      main.style.cssText = css
      this.scrollHeight = top
    },
    timeZone(val) {
      if (!val) return ''
      if (val) {
        const localTime = utils.getLocalTime(Number(this.timeZones.substr(3)), val)
        return new Date(localTime).format('Y-MM-dd hh:mm:ss')
      }
    },
    closeProfitAndLossPop() {
      this.removeStyle()
      this.isShowProfitAndLoss = false
    },
    selectProfitAndLossPro(data) {
      this.addStyle()
      this.isShowProfitAndLoss = !this.isShowProfitAndLoss
      this.dealId = data.dealId
      this.displayName = data.displayName
      this.orderTypeStr = data.orderTypeStr
      this.openDirection = data.openDirection
      this.tradeVolume = data.tradeVolume
      this.tradePriceStr = data.tradePriceStr
      this.openPriceStr = data.openPriceStr
      this.swap = data.swap
      this.profit = data.profit
      this.dealid = data.dealid
      this.commission = data.commission
      this.openNo = data.openNo
      this.openTime = data.openTime
      this.tradeTime = data.tradeTime
      this.remark = data.remark
    },
    selectBrush() {
      this.toggleFixed()
      let isShowTradeType = this.isBrushTradePop
      isShowTradeType = !isShowTradeType
      this.$emit('blushPop', isShowTradeType)
    },
    classType(obj) {
      let val
      if (this.pattern) {
        if (this.pattern == 'redGreen') {
          if (obj > 0) val = 'fall reverse'
          else if (obj < 0) val = 'rise reverse'
          else if (obj == 0) val = ''
          else if (obj == '买') val = 'buy'
          else if (obj == '卖') val = 'sell'
        } else if (this.pattern == 'greenRed') {
          if (obj > 0) val = 'rise'
          else if (obj < 0) val = 'fall'
          else if (obj == 0) val = ''
          else if (obj == '买') val = 'sell'
          else if (obj == '卖') val = 'buy'
        }
      } else {
        if (obj > 0) val = 'rise'
        else if (obj < 0) val = 'fall'
        else if (obj == 0) val = ''
        else if (obj == '买') val = 'sell'
        else if (obj == '卖') val = 'buy'
      }
      return val
    }
  }
}
</script>
